import { CHART_TYPES } from "../../pages/Statistics/statisticsConstants";

const initialState = {
  StatisticsCharts: {
    chart: window.REACT_APP_DEFAULT_APACHE_CHARTS === "true" ? CHART_TYPES.APACHE_CHARTS : CHART_TYPES.KNOWI,
  },
};

const userAppSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_STATISTICS_CHART_TYPE": {
      return {
        ...state,
        StatisticsCharts: {
          ...state.StatisticsCharts,
          chart: action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export default userAppSettingsReducer;
